import React, { Component } from "react";
import PropTypes from "prop-types";
import { Container } from "../../../components/atoms/Container";
import { Section } from "../../../components/atoms/Section";
import GuidesPosts from "../../../components/atoms/GuidesPosts";
import BreadCrumbBar from "../../../components/atoms/BreadCrumbBar";
import { GUIDES_TAB_BAR_SLUG, GUIDES_TAB_HEADER_COLOR, GUIDES_TITLE_NAME } from "../../../helpers/constants";

import suitcase from "../../../assets/images/guides/suitcase.png";

import GuidesHeader from "../../../components/molecules/GuidesHeader";
import urlPatterns from "../../../urls";
import { header } from "../../../styles/variables";
import GuidesTabNavigator from "../../../components/molecules/GuidesTabNavigator";

class GuidesTabAll extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showBreadCrumbBar: true,
    };
  }

  async componentDidMount() {
    const { match, history, location } = this.props;
    const { params } = match || {};
    const { slug } = params || {};
    if (slug) {
      const { search } = location || {};
      history.push({
        pathname: urlPatterns.GUIDE_101_POST(slug),
        search,
      });
    }
  }

  render() {
    const { history, location } = this.props;

    const { showBreadCrumbBar } = this.state;

    return (
      <>
        <GuidesHeader
          headerIcon={suitcase}
          headerColor={GUIDES_TAB_HEADER_COLOR.WINE_101_GUIDES}
          headerTitle={GUIDES_TITLE_NAME.WINE_101_GUIDES}
          headerDescription="The basics. Pretty much everything. A great place to start."
        />
        <GuidesTabNavigator
          mobileHeaderStyleTop={header.mobileHeight}
          shouldDisappearOnMobile
          backgroundColor={GUIDES_TAB_HEADER_COLOR.WINE_101_GUIDES}
          url101={urlPatterns.GUIDE_101}
          location={location}
        />
        <Section xxs>
          {showBreadCrumbBar && (
            <BreadCrumbBar homeLabel="Guides" parentLabel="Wine 101 Guides" location={location} />
          )}
          <Container>
            <GuidesPosts
              history={history}
              filters={`${GUIDES_TAB_BAR_SLUG.WINE_101_GUIDES}`}
              parentName="Wine For Beginners: The #1 Wine 101 Guide | Good Pair Days"
              metaDescription="Keen to learn about wine? We have put the ultimate Wine 101 Guide together
              that covers everything from the main wine styles to how wine is made and more!"
              isFromTabAll
              location={location}
            />
          </Container>
        </Section>
      </>
    );
  }
}

GuidesTabAll.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  match: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
};

export default GuidesTabAll;
